export default __webpack_public_path__ + "../img/b207bbaee3f514c7bd6295661b32e2c0.png";